import ObmenkaDepositClass from './ObmenkaDepositClass';
import {inject, observer} from 'mobx-react';

@inject('depositsStore')
@observer
export default class ObmenkaDeposit extends ObmenkaDepositClass {}
